
import React from 'react';
import "../../css/layout/sidebar.css";
import PopulationRow from './rows/SidebarPopulationRow';
import SidebarGDPRow from './rows/SidebarGDPRow';
import SidebarWorldRow from './rows/SidebarWorldRow';
import SidebarDebtRow from './rows/SidebarDebtRow';
import SidebarToolsRow from './rows/SidebarToolsRow';

const SideBarMobile =  ({menuToggle}) => {
    
        let width = "0px";
        if(!menuToggle){
            width = "200px";
        } else{
        }

        

        return(

                <div className="sidebar-menu-div-mobile" style={{width: width}}> 
                    
                    <div className="sidebar-menu-items">
                        <ul>
                        <li><a href="/" className='header-tab-mobile'>
                            <img src="/resources/icons/menu/home.png" alt="Home Icon" className='sidebar-menu-svg'/>
                            <p>Home</p></a></li>
                            <li><a href="/country" className='header-tab-mobile'>
                            <img src="/resources/icons/menu/country.png" alt="Country Icon" className='sidebar-menu-svg'/>
                            <p>Country</p></a></li>
                            <li><a href="/world" className='header-tab-mobile' >
                            <img src="/resources/icons/menu/world.png" alt="World Icon" className='sidebar-menu-svg'/>
                            <p>World</p></a></li>
                            <li><a href="/About" className='header-tab-mobile'>
                            <img src="/resources/icons/menu/about.png" alt="About Icon" className='sidebar-menu-svg'/>
                            <p>About</p></a></li>
        
                                <PopulationRow/>
                                < SidebarWorldRow/>
                                <SidebarGDPRow/>
                            <li>
                                < SidebarDebtRow/>
                            </li>
                            <li>
                                <SidebarToolsRow/>
                            </li>
                        </ul>
                       
                    </div>
                </div>

        );
        
}


export default SideBarMobile;